import { call, put } from 'redux-saga/effects'
import { PayloadAction } from '@reduxjs/toolkit'
import apiMiddleware from 'services/api_middleware'
import app_config from 'config/app_config'

import { onOpenNotification } from 'redux/notification/reducer'

import {
	deleteInvoicesRequestFailure,
	deleteInvoicesRequestSuccess,
} from '../reducer'

export function* deleteInvoicesSaga({
	payload,
}: PayloadAction<{ invoiceIds: string[] }>) {
	try {
		const { message }: { message: string } = yield call(apiMiddleware, {
			url: app_config.services.deleteInvoice,
			method: 'POST',
			data: payload,
		})

		yield put(
			onOpenNotification({
				message,
				notificationType: 'success',
			})
		)

		yield put(deleteInvoicesRequestSuccess())
	} catch (e) {
		yield put(deleteInvoicesRequestFailure())

		const error = e as { message: string }

		yield put(
			onOpenNotification({
				message: error.message,
				notificationType: 'error',
			})
		)
	}
}
